export default class CharacterItem extends Phaser.GameObjects.Image {
  /**
   *  A simple prefab (extended game object class), displaying a spinning
   *  Phaser 3 logo.
   *
   *  @extends Phaser
   */
  constructor(scene, x, y, item, id, objID, scale) {
    //super(scene, x, y, 'freeplaceItems', item + '.png');
    super(scene, x, y, 'freeplaceItems', item + '.png');
    this.name = item;
    this.itemID = id;
    this.objID = objID;
    scene.add.existing(this);
    this.setOrigin(0.5);
    this.setDepth(5);
    this.itemDraggable = false;
    this.charScale = scale;
    this.emitter = new Phaser.Events.EventEmitter();
    // this.depth = 100 + this.y;
    this.texWidth = this.width * this.charScale;// * this.charScale;
    this.texHeight = this.height * this.charScale;// * this.charScale;
    this.setDisplaySize(this.texWidth, this.texHeight);
    //this.width = this.width * scale;
    //this.height = this.height * scale;
    //console.log('sprite scaling --> ' + scale);
    //console.log('sprite width --> ' + this.displayWidth);
  }

  update(time, delta) {
    if (this.itemDraggable) {
      this.dragTime += delta;
    }
  }

  toggleInteractive(scene, toggleOn) {
    if (toggleOn) {
      this.setInteractive();
      scene.input.setDraggable(this);
      this.alpha = 1;
      scene.input.on(
        'dragstart',
        function (pointer, gameObject) {
          if (gameObject === this) {
            let width = gameObject.width / 2;
            let height = gameObject.height / 2;
            if (pointer.x >= gameObject.x - width && pointer.x <= gameObject.x + width &&
              pointer.y >= gameObject.y - height && pointer.y <= gameObject.y + height) {
              gameObject.itemDraggable = true;
              gameObject.sqrDragDist = 0;
            }
          }
        },
        this
      );
      scene.input.on('drag', function (pointer, gameObject, dragX, dragY) {
        if (gameObject.itemDraggable === true) {
          let x = gameObject.x - dragX;
          let y = gameObject.y - dragY;
          gameObject.sqrDragDist += x * x + y * y;
          gameObject.x = dragX;
          gameObject.y = dragY;
        }
      });

      scene.input.on(
        'dragend',
        function (pointer, gameObject) {
          if (gameObject === this && gameObject.itemDraggable) {
            gameObject.itemDraggable = false;
            gameObject.emitter.emit('touchUp', pointer, this);
          }
        },
        this
      );
    } else {
      this.alpha = 0;
    }
  }

  destroy() {
    if (this.emitter != null) {
      this.emitter.destroy();
      this.emitter = null;
    }

    super.destroy();
  }
}
